export default {
    getLogsLacin: (fromDate, toDate) => {
        return {
            url: '/logs/env/:env',
            method: 'GET',
            route_params: {
                env: 'lacin'
            },
            get_params: {
                fromDate,
                toDate
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/logging/data/LogsLacin/api.js